import { Component, OnInit, inject } from '@angular/core';
import { NotificationCenterService } from '../notification-center.service';
import { PhitoNotification } from '../classes/PhitoNotification';
import { PhitoNotificationType } from '../classes/PhitoNotificationType';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PhitoSessionService } from '../../../services/phito-session.service';
import { NotificationPopupItemComponent } from '../notification-popup-item/notification-popup-item.component';

@Component({
    selector: 'phito-notification-center',
    templateUrl: './notification-center.component.html',
    styleUrls: ['./notification-center.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [style({ opacity: 0 }), animate('400ms', style({ opacity: 1 }))]),
            transition(':leave', [style({ opacity: 1 }), animate('400ms', style({ opacity: 0 }))]),
        ]),
    ],
    imports: [NotificationPopupItemComponent],
})
export class NotificationCenterComponent implements OnInit {
    private notificationCenterService = inject(NotificationCenterService);
    private sessionService = inject(PhitoSessionService);

    notifications: PhitoNotification[] = [];
    openedOverlay = false;

    ngOnInit(): void {
        // add a notification every 5 seconds
        // setInterval(() => {
        //   const notification = new PhitoNotification();
        //   console.log('ADDED NOTIFICATION', notification);
        //   notification.id = Math.random().toString();
        //   notification.notificationText = ' Lorem ipsum dolor sit amet,t, sed diam voluptua. At';
        //   notification.notificationTitle = 'Notification title';
        //   notification.type = PhitoNotificationType.INFORMATION;
        //   notification.createdAt = new Date();
        //   notification.createdBy =  this.sessionService.getLoggedInUser();
        //   this.notifications.unshift(notification);
        //   this.close(notification);
        // }, 2000);

        this.notificationCenterService.watchNotificationOverlay().subscribe((opened) => {
            this.openedOverlay = opened;
        });

        this.notificationCenterService.watchNotificationPipeline().subscribe((notification) => {
            if (notification.read) {
                this.notifications = this.notifications.filter((n) => n.id !== notification.id);
            } else {
                this.notifications.unshift(notification);
            }
            this.close(notification);
        });
    }

    close(notification: PhitoNotification) {
        // Critical notifications won't close automatically
        if (notification.type === PhitoNotificationType.CRITICAL) {
            return;
        }

        setTimeout(() => {
            this.notifications = this.notifications.filter((n) => n.id !== notification.id);
        }, 30000);
    }

    closeNotification(alert: PhitoNotification) {
        this.notifications = this.notifications.filter((n) => n.id !== alert.id);
        this.notificationCenterService.markNotificationAsRead(alert).subscribe({
            next: () => {
                // list will be updated through watchNotificationPipeline automatically
            },
            error: (err) => {
                console.log('READ NOTIFICATION ERROR', err);
            },
        });
    }
}
